import React, {Component} from "react";
import {connect} from "react-redux";
import {Route, Switch, NavLink, Redirect} from "react-router-dom";
import swal from "sweetalert";
import {Base} from "zina-dogi-react";
import * as oet from "~/sode/oet/redux";
import * as oet_non_sode from "~/non-sode/oet/redux";
import {utils} from "~/utils";
import {RunCreatorModal} from "~/sode/run";
import {RunTable, OETBasicInfo, NonSodeTracker} from "../components";
import {actions as inboxActios, selectors as inboxSelectors} from "../../inbox";
// import { TrackerTable, ServiceOrderTable } from "~/sode/oet";

const STATUS = ["logistics_oet", "on_run", "closed", "cancelled"];

class OetContainer extends Component {
    obit = React.createRef();

    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
            status: null
        };
    }

    componentWillMount() {
        const {oetID, getDetails, history} = this.props;
        if (oetID) {
            getDetails(oetID, history);
        }
    }

    componentDidUpdate(prevProps) {
        const {non_sode, getNonSodeDetail, oet} = this.props;
        const prevCpoId = prevProps.oet && prevProps.oet.customer_purchase_order
            ? prevProps.oet.customer_purchase_order.id
            : null;
        const currentCpoId = oet && oet.customer_purchase_order ? oet.customer_purchase_order.id : null;

        // Fetch only when the related CPO changes to avoid dispatching on every update.
        if (!non_sode && currentCpoId && prevCpoId !== currentCpoId) {
            getNonSodeDetail(currentCpoId);
        }
    }

    get hasCpo() {
        const {oet} = this.props;
        const noc = oet && oet.hasOwnProperty("customer_purchase_order") && oet.customer_purchase_order;
        return !!noc;
    }

    render() {
        const {status, oet, non_sode, loading, extraProps} = this.props;
        const hasRedirect = !this.props.oetID && this.props.location.pathname !== "/";
        const base_op = {
            className: "cpo_tracker",
            title: `OET #${oet ? oet.id_zfill : ""}`,
            breadcrumbs: [
                {name: "Home", rel: "/", icon: "home"},
                {name: "NON SODE Inbox", rel: "/non-sode/"},
                {
                    name: `NON SODE${this.hasCpo ? ` #${oet.customer_purchase_order.non_sode}` : ""}`,
                    rel: `/non-sode/${this.hasCpo ? oet.customer_purchase_order.id : ""}`
                },
                {name: `OET #${oet ? oet.id_zfill : ""}`}
            ],
            extraProps,
            loading
        };
        return (
            <div style={{height: "100%"}}>
                {hasRedirect && <Redirect to="/non-sode/"/>}
                <Base {...base_op}>
                    <NonSodeTracker
                        onSubmit={this.onFilter}
                        onCancel={this.onCancel}
                        send_create_scratch_po_job={this.props.send_create_scratch_po_job}
                        oet={oet}
                        status={status}
                        nonSode={non_sode}
                    />
                    {this.computeTabs(this.props.oetID, status)}
                </Base>
            </div>
        );
    }

    save = data => {
        const {oet, status, history} = this.props;
        switch (status) {
            case 0:
            case 1:
                this.props.saveLogistic(oet.id, data, history);
                break;
            default:
                break;
        }
    };

    updateStatus = status => {
        const {updateSatus, oet, history} = this.props;
        if (oet) {
            updateSatus(oet.id, status, history).catch(error => {
                let errors = [];
                try {
                    const j = JSON.parse(error.response.data.status);
                    if (j.permission) {
                        errors.push(j.permission);
                    }
                    if (j.runs && j.runs.error) {
                        errors.push(j.runs.error);
                    }
                } catch (e) {
                    console.log("error");
                }
                swal({
                    title: "Error",
                    text: errors.length ? errors.join("\n") : utils.computeError(error),
                    icon: "warning",
                    timer: 3000,
                    button: true
                });
            });
        }
    };

    computeTabs = (oetID, status) => {
        const {oet, non_sode} = this.props;
        let addRunDisabled = true;
        if (oet && oet.status === "logistics_oet") {
            const onRun = oet.available_status_transitions.find(step => step.slug === "on_run");
            // esto debe llevar una negacion se la quite para poder desarrollar la sigiente vista
            addRunDisabled = !onRun.can_change_status;
        } else if (oet && oet.status === "on_run") {
            addRunDisabled = false;
        }
        const path = "/non-sode/oet/:oetID/";
        const runPath = "/non-sode/oet/:oetID/runs/";
        console.log('this.props.oet: ', this.props.oet);
        return (
            <div>
                {this.props.oet && (
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "flex-end"
                        }}
                    >
                        <RunCreatorModal
                            oet={this.props.oet}
                            onCreateRun={this.onCreateRun}
                            className="run-creator"
                            disabled={addRunDisabled}
                        />
                    </div>
                )}
                <ul className="nav nav-tabs">
                    <li className="nav-item">
                        <NavLink exact to={path.replace(":oetID", oetID)} className="nav-link" activeClassName="active">
                            OET Basic Information
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink
                            exact
                            to={runPath.replace(":oetID", oetID)}
                            className="nav-link"
                            activeClassName="active"
                        >
                            Runs
                        </NavLink>
                    </li>
                </ul>
                <div className="tabs">
                    <Switch>
                        <Route
                            exact
                            path={path}
                            render={props => (
                                <OETBasicInfo
                                    {...props}
                                    onItemsChange={this.onItemsChange}
                                    oet={oet}
                                    nonSode={non_sode}
                                    status={status}
                                />
                            )}
                        />
                        <Route
                            exact
                            path={runPath}
                            render={props => (
                                <div>
                                    <RunTable
                                        {...props}
                                        onItemsChange={this.onItemsChange}
                                        oet={this.props.oet}
                                        status={status}
                                        history={this.props.history}
                                    />
                                </div>
                            )}
                        />
                        <Redirect to={path.replace(":oetID", oetID)}/>
                    </Switch>
                </div>
            </div>
        );
    };

    projectLinks = (url, status) => {
        return [
            <li className="nav-item" key="tab-project-2">
                <NavLink exact to={`${url}/siteserv`} className="nav-link" activeClassName="active">
                    Service Order
                </NavLink>
            </li>
        ];
    };

    projectTabs = (url, status) => {
        return [
            // <Route
            //     exact
            //     key="project-tab-2"
            //     path={`${url}/siteserv`}
            //     render={props => (
            //         <ServiceOrderTable
            //             {...props}
            //             oet_ssoti={this.props.oet ? this.props.oet.ssoti : null}
            //             status={status}
            //         />
            //     )}
            // />
        ];
    };

    onFilter = values => {
        this.save(values);
    };

    onCancel = () => {
        this.updateStatus("cancelled");
    };

    onItemsChange = ev => {
        const {oet, history, saveItem} = this.props;
        saveItem(oet.id, ev.newItem, history);
    };

    onCreateRun = ({item_id, name}) => {
        const {createRun, oetID, history} = this.props;
        createRun(
            oetID,
            item_id,
            history,
            run => {
                swal({
                    title: "Successfully created!",
                    text: `Run #${run.number}`,
                    icon: "success",
                    timer: 3000,
                    button: true
                });
            },
            error => {
                let {status, data, response} = error;
                if(status === undefined && data===undefined && response !== undefined){
                    ({status, data} = response);
                }
                switch (status) {
                    case 400:
                        const mgs = Object.keys(data)
                            .map(key => {
                                const mg = data[key];
                                return `${mg}`.split("_").join(" ");
                            })
                            .join("\n");
                        swal({
                            title: "Error!",
                            text: mgs,
                            icon: "error",
                            // timer: 3000,
                            button: true
                        });
                        break;
                    default:
                        swal({
                            title: "Error!",
                            text: "something went wrong!",
                            icon: "error",
                            timer: 3000,
                            button: true
                        });
                        break;
                }
            }
        );
    };
}

const computeStatus = oet => (oet ? STATUS.indexOf(oet.status) : null);

const mapStateToProps = (store, ownProps) => ({
    non_sode: inboxSelectors.nonSodeSelected(store.non_sode),
    oet: store.oet.oetSelected,
    status: computeStatus(store.oet.oetSelected),
    oetID: ownProps.match.params.oetID,
    loading: store.oet.loading
});

const mapDispatchToProps = dispatch => ({
    getNonSodeDetail: id => dispatch(inboxActios.getById(id)),
    getDetails: (oetID, history) => dispatch(oet.actions.getOetInDetail(oetID, history)),
    updateSatus: (oetID, status, history) => dispatch(oet.actions.changeOETStatus(oetID, status, history)),
    saveLogistic: (oetID, body, history) => dispatch(oet.actions.updateLogistic(oetID, body, history)),
    saveItem: (oetID, item, history) => dispatch(oet.actions.updateOETItem(oetID, item, history)),
    createRun: (oet_id, oet_item, history, ok, fail) => dispatch(oet.actions.createRun(oet_id, oet_item, history, 'non_sode', ok, fail)),
    send_create_scratch_po_job: (run_id, fn) => dispatch(oet_non_sode.actions.send_create_scratch_po_job(run_id, fn))
});

export default connect(mapStateToProps, mapDispatchToProps)(OetContainer);
